class x {
  experiment;
  get name() {
    return this.experiment.name;
  }
  get variation() {
    return this.experiment.variation;
  }
  constructor(e) {
    this.experiment = e;
  }
}
class l {
  constructor(e, t) {
    this.experimentsDataStore = e, this.experimentsRestClient = t, setTimeout(() => {
      this.resolveRejectPromise();
    }, 1e3);
  }
  ongoingExperiments = new Array();
  promiseResolve = () => {
  };
  promiseReject = () => {
  };
  promiseObject;
  getExperiment(e) {
    const t = this.experimentsDataStore.getExperimentByName(
      e.experimentName
    );
    this.ongoingExperiments.push(e.experimentName);
    const r = this.trySaveExperimentFromWebApiToStore(e);
    if (t === void 0)
      return r;
    {
      const s = new x(t);
      return r.then((n) => {
        n !== void 0 && (s.experiment = n);
      }), Promise.resolve(s);
    }
  }
  getCachedExperiments() {
    return this.experimentsDataStore.getExperiments();
  }
  allExperimentsHaveInitialized() {
    return this.promiseObject !== void 0 ? (this.promiseResolve("All experiments already initialized"), Promise.resolve()) : (this.promiseObject = new Promise((e, t) => {
      this.promiseResolve = e, this.promiseReject = t;
    }), this.promiseObject);
  }
  resolveRejectPromise() {
    try {
      this.ongoingExperiments.length === 0 && this.promiseResolve("All experiments initialized");
    } catch (e) {
      this.promiseReject(e.message);
    }
  }
  async getExperimentFromWebApi(e) {
    const t = await this.experimentsRestClient.getOrAddExperimentVariation(
      e
    );
    return this.ongoingExperiments = this.ongoingExperiments.filter(
      (r) => r !== e.experimentName
    ), this.resolveRejectPromise(), t.succeeded ? t.result : void 0;
  }
  saveExperimentToStore(e, t) {
    t !== void 0 ? this.experimentsDataStore.setExperiment(t) : this.experimentsDataStore.removeExperiment(
      e.experimentName
    );
  }
  async trySaveExperimentFromWebApiToStore(e) {
    const t = await this.getExperimentFromWebApi(e);
    return this.saveExperimentToStore(e, t), t;
  }
}
class $ {
  constructor(e, t) {
    this.experimentName = e, this.countryCode = t;
  }
  productCode;
  buyOptionName;
}
let E = class extends Error {
  url;
  originalError;
  constructor(e, t) {
    super(`fetch failed when requesting the url: "${e}"`), this.url = e, this.originalError = t;
  }
};
class u extends Error {
  url;
  response;
  constructor(e, t) {
    super(`A request to "${e}" received a failed response.`), this.url = e, this.response = t;
  }
}
var c = /* @__PURE__ */ ((i) => (i.PUT = "PUT", i.PATCH = "PATCH", i.DELETE = "DELETE", i.GET = "GET", i.POST = "POST", i))(c || {});
async function d(i, e, t) {
  const r = new URL(e, t?.origin ?? window.location.origin);
  i === "GET" && (t?.data?.brand !== void 0 && ["+", "", "%2B", "None"].includes(t.data.brand) && delete t.data.brand, r.search = new URLSearchParams(t?.data).toString());
  let s = "same-origin";
  t?.mode && (s = t.mode);
  const n = {
    Accept: "application/json"
  };
  t?.secureId && (n.Authorization = `secure_id ${t.secureId}`), t?.data instanceof FormData || (n["Content-Type"] = "application/json;charset=UTF-8");
  let o;
  try {
    o = await fetch(r.href, {
      method: i,
      mode: s,
      credentials: t?.credentials,
      headers: n,
      ...i !== "GET" ? g(t?.data) : null
    });
  } catch (h) {
    throw new E(r.href, h);
  }
  if (o.ok)
    return o.json();
  throw new u(r.href, o);
}
function g(i) {
  return i instanceof FormData ? {
    body: i
  } : {
    body: JSON.stringify(i)
  };
}
const S = "/api/foundation/user/v1/user-experiment";
class y {
  constructor(e = S) {
    this.apiPath = e;
  }
  async getOrAddExperimentVariation(e) {
    const t = await d(
      c.POST,
      this.apiPath,
      {
        data: e
      }
    );
    return {
      succeeded: t.succeeded,
      result: {
        name: t.result?.experimentName ?? "",
        variation: t.result?.variationName ?? ""
      },
      errors: t.errors
    };
  }
}
class m {
  isSecure = !0;
  maxAgeInSeconds = 31536e3;
  maxAgeInDays;
  domain;
  sameSite;
}
let v = class {
  generateCookieString(e, t) {
    let r = `${e.cookieName}=${encodeURIComponent(
      e.cookieValue
    )}${t.isSecure ? ";Secure" : ""}`;
    if (t.domain && (r = `${r};domain=${t.domain}`), t.maxAgeInDays) {
      const s = new Date();
      s.setTime(
        s.getTime() + t.maxAgeInDays * 24 * 60 * 60 * 1e3
      ), r = `${r};expires=${s.toUTCString()}`;
    } else
      r = `${r};max-age=${t.maxAgeInSeconds}`;
    return t.sameSite && (r = `${r};samesite=${t.sameSite}`), r;
  }
};
class f {
  constructor(e = new v()) {
    this.stringGenerator = e;
  }
  getCookieByName(e) {
    const t = e + "=", r = document.cookie.split(";");
    for (const s of r) {
      const n = s.trimStart();
      if (n.indexOf(t) === 0) {
        const o = n.substring(
          t.length,
          n.length
        );
        return decodeURIComponent(o);
      }
    }
  }
  setCookie(e, t = new m()) {
    document.cookie = this.stringGenerator.generateCookieString(
      e,
      t
    );
  }
  removeCookie(e) {
    const t = new m();
    t.maxAgeInSeconds = 0;
    const r = {
      cookieName: e,
      cookieValue: ""
    };
    this.setCookie(r, t);
  }
}
const I = new f();
function w(i) {
  return I.getCookieByName(i);
}
const N = "dcsExp";
class C {
  getExperimentByName(e) {
    const t = this.getExperiments();
    if (t.length !== 0)
      return t.find((r) => r.name === e);
  }
  getExperiments() {
    return this.getSemicolonSeparatedExperimentsFromCookies().split(";").filter((e) => e.includes("=")).map((e) => {
      const t = e.split("=");
      return { name: t[0], variation: t[1] };
    });
  }
  setExperiment() {
  }
  setExperiments() {
  }
  removeExperiment() {
  }
  getSemicolonSeparatedExperimentsFromCookies() {
    return w(N) ?? "";
  }
}
class P {
  constructor(e, t, r) {
    this.inMemoryStore = e, this.persistentStore = t, this.cookieStore = r;
  }
  wereExperimentsRestoredFromPersistentStore = !1;
  getExperimentByName(e) {
    return this.restoreExperimentsFromLocalStores(), this.inMemoryStore.getExperimentByName(e) ?? this.cookieStore.getExperimentByName(e);
  }
  getExperiments() {
    return this.restoreExperimentsFromLocalStores(), this.combineExperiments([this.inMemoryStore, this.cookieStore]);
  }
  setExperiment(e) {
    this.inMemoryStore.setExperiment(e), this.persistentStore.setExperiment(e);
  }
  setExperiments(e) {
    this.inMemoryStore.setExperiments(e), this.persistentStore.setExperiments(e);
  }
  removeExperiment(e) {
    this.inMemoryStore.removeExperiment(e), this.persistentStore.removeExperiment(e);
  }
  restoreExperimentsFromLocalStores() {
    this.wereExperimentsRestoredFromPersistentStore || (this.inMemoryStore.setExperiments(this.persistentStore.getExperiments()), this.wereExperimentsRestoredFromPersistentStore = !0);
  }
  combineExperiments(e) {
    const t = {};
    for (const r of e)
      r.getExperiments().forEach((s) => t[s.name] = s);
    return Object.values(t);
  }
}
class T {
  experimentByNameMap = {};
  getExperimentByName(e) {
    return this.experimentByNameMap[e];
  }
  getExperiments() {
    return Object.values(this.experimentByNameMap);
  }
  setExperiment(e) {
    this.experimentByNameMap[e.name] = e;
  }
  setExperiments(e) {
    for (const t of e)
      this.experimentByNameMap[t.name] = t;
  }
  removeExperiment(e) {
    delete this.experimentByNameMap[e];
  }
}
class R {
  constructor(e, t) {
    this.value = e, this.expiryDate = t;
  }
}
const D = "_", A = 30 * 24 * 60 * 60;
class k {
  setItem(e, t, r = A) {
    const s = this.createExpiryDate(r).toJSON(), n = new R(t, s), o = JSON.stringify(n);
    localStorage.setItem(e, o);
  }
  getItem(e) {
    this.assertNotEmpty(e, "key");
    const t = this.getCacheEntry(e);
    if (t !== void 0) {
      if (t.expiryDate !== void 0 && this.isInThePast(new Date(t.expiryDate))) {
        this.removeItem(e);
        return;
      }
      return t.value;
    }
  }
  removeItem(e) {
    localStorage.removeItem(e);
  }
  removeAllItems() {
    localStorage.clear();
  }
  removeAllItemsWithKeyContainingString(e) {
    for (let t = localStorage.length - 1; t >= 0; t--) {
      const r = localStorage.key(t);
      r && r.indexOf(e) !== -1 && this.removeItem(r);
    }
  }
  removeExpiredItems() {
    const e = this.findExpiredKeys();
    this.removeItems(e);
  }
  getSize() {
    return localStorage.length;
  }
  createKey(e, t, ...r) {
    return this.assertNotEmpty(e, "domain"), this.assertNotEmpty(t, "moduleName"), [
      e,
      t,
      ...r.filter((s) => s !== void 0)
    ].map((s) => s.toLowerCase()).join(D);
  }
  getCacheEntry(e) {
    const t = localStorage.getItem(e);
    if (t !== null)
      try {
        return JSON.parse(t);
      } catch {
        return;
      }
  }
  removeItems(e) {
    for (const t of e)
      this.removeItem(t);
  }
  findExpiredKeys() {
    const e = [];
    for (let t = 0; t < localStorage.length; ++t) {
      const r = localStorage.key(t);
      if (r === null)
        continue;
      const s = this.getCacheEntry(r);
      s !== void 0 && this.isInThePast(new Date(s.expiryDate)) && e.push(r);
    }
    return e;
  }
  assertNotEmpty(e, t) {
    if (e.length === 0)
      throw new Error(`The ${t} must not be empty.`);
  }
  createExpiryDate(e) {
    const t = new Date();
    return t.setSeconds(t.getSeconds() + e), t;
  }
  isInThePast(e) {
    return new Date() > e;
  }
}
var p = /* @__PURE__ */ ((i) => (i.Foundation = "foundation", i))(p || {});
const b = new k();
function F() {
  return b;
}
class M {
  constructor(e = F()) {
    this.cache = e;
  }
  getExperimentByName(e) {
    const t = this.cache.getItem(
      this.createCacheKey()
    );
    if (t !== void 0)
      return t.find((r) => r.name === e);
  }
  getExperiments() {
    return this.cache.getItem(this.createCacheKey()) ?? [];
  }
  setExperiment(e) {
    const t = this.getExperiments();
    this.setExperiments([
      e,
      ...t.filter((r) => r.name !== e.name)
    ]);
  }
  setExperiments(e) {
    this.cache.setItem(this.createCacheKey(), e);
  }
  removeExperiment(e) {
    const t = this.getExperiments();
    this.setExperiments([...t.filter((r) => r.name !== e)]);
  }
  createCacheKey() {
    return this.cache.createKey(p.Foundation, "experiments");
  }
}
class O {
  createStore() {
    const e = new T(), t = new M(), r = new C();
    return new P(
      e,
      t,
      r
    );
  }
}
const a = (() => {
  const e = new O().createStore(), t = new y();
  return new l(e, t);
})();
function K(i) {
  return a.getExperiment(i);
}
function U() {
  return a.allExperimentsHaveInitialized();
}
function L() {
  return a.getCachedExperiments();
}
export {
  a as EXPERIMENTS_PROVIDER,
  $ as ExperimentOptions,
  U as allExperimentsHaveInitialized,
  L as getCachedExperiments,
  K as getExperiment
};
//# sourceMappingURL=index.js.map
